import ErrorBoundary from "@common/controls/ErrorBoundary/component";
import * as React from "react";

export interface BodyProps {
  children?: any;
  maxHeight?: number | string;
}

export default class Body extends React.Component<BodyProps> {
  public render() {
    const { children, maxHeight } = this.props;

    return (
      <div className="modal-body" style={{ maxHeight }}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </div>
    );
  }
}
